import { render, staticRenderFns } from "./broadcast-category.vue?vue&type=template&id=5b73dc0a"
import script from "./broadcast-category.vue?vue&type=script&lang=js"
export * from "./broadcast-category.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports